// ========================================
// CONFIG
// ========================================

const APP_LINK = "https://YOUR-APP-LINK";

// Product regions from Shopify metafield
const PRODUCT_REGIONS = window.PRODUCT_REGIONS || [];

// Hardcoded all-India fallback product (ghee), populated from Liquid
const GHEE_PRODUCT = window.GHEE_PRODUCT || { available: false };

// Other product links to show alongside the ghee fallback.
// Each entry needs a "handle" (matches the product URL's last segment)
// so the currently-viewed product can be excluded from its own list.
const ALL_OTHER_PRODUCTS = [
    {
        handle: "moovana-a2-paneer",
        title: "Moovana A2 Paneer",
        url: "https://moovana.in/products/moovana-a2-paneer"
    },
    {
        handle: "the-dairy-milk",
        title: "The Dairy Milk",
        url: "https://moovana.in/products/the-dairy-milk"
    }
];

const CURRENT_PRODUCT_HANDLE = window.CURRENT_PRODUCT_HANDLE || "";

const OTHER_PRODUCTS = ALL_OTHER_PRODUCTS.filter(
    p => p.handle !== CURRENT_PRODUCT_HANDLE
);

// ========================================
// SHARED MATCHING LOGIC
// ========================================

function normalizeRegion(str) {
    return (str || "")
        .toLowerCase()
        .replace(/\(.*?\)/g, "")   // strip "(Assam)" style suffixes
        .replace(/[^a-z\s]/g, "")  // strip punctuation
        .trim();
}

function isRegionSupported(office) {

    const district = (office.District || "").trim();
    const state = (office.State || "").trim();
    const division = (office.Division || "").trim();
    const region = (office.Region || "").trim();
    const officeName = (office.Name || "").trim();

    const allowedRegions = PRODUCT_REGIONS
        .map(normalizeRegion)
        .filter(Boolean);

    // If the product is available across India, allow every PIN
    if (allowedRegions.includes("india")) {
        return {
            supported: true,
            district: office.District || "",
            state: office.State || ""
        };
    }

    const apiValues = [district, state, division, region, officeName]
        .filter(Boolean)
        .map(normalizeRegion);

    // Bidirectional substring match — handles cases like
    // productRegion "guwahati assam" vs apiValue "kamrup metropolitan"
    // as well as exact matches like "sikkim" vs "sikkim"
    const supported = allowedRegions.some(productRegion =>
        apiValues.some(apiValue =>
            apiValue === productRegion ||
            apiValue.includes(productRegion) ||
            productRegion.includes(apiValue)
        )
    );

    return { supported, district, state };
}

// ========================================
// DOM READY
// ========================================

document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.getElementById("deliveryOverlay");
    const openBtn = document.getElementById("openDeliveryModal");
    const closeBtn = document.getElementById("closeDeliveryModal");
    const checkBtn = document.getElementById("check-delivery");
    const pinInput = document.getElementById("delivery-pincode");
    const result = document.getElementById("delivery-result");
    const deliveryText = document.querySelector(".delivery-text");

    if (!overlay || !openBtn) return;

    // ------------------------------
    // Always open the modal on every
    // product page visit, and re-check
    // any saved PIN against THIS product
    // ------------------------------

    const savedPinOnLoad = localStorage.getItem("deliveryPin");

    openModal();

    if (savedPinOnLoad) {
        pinInput.value = savedPinOnLoad;
        checkDelivery();
    }

    // ------------------------------
    // Open Modal
    // ------------------------------

    function openModal() {

        overlay.classList.add("active");

        result.innerHTML = "";

        const savedPin = localStorage.getItem("deliveryPin");

        if (savedPin) {
            pinInput.value = savedPin;
        }

        pinInput.focus();

    }

    openBtn.addEventListener("click", openModal);

    // ------------------------------
    // Close Modal
    // ------------------------------

    closeBtn.addEventListener("click", () => {
        overlay.classList.remove("active");
    });

    // ------------------------------
    // Click Outside
    // ------------------------------

    overlay.addEventListener("click", (e) => {
        if (e.target === overlay) {
            overlay.classList.remove("active");
        }
    });

    // ------------------------------
    // Escape Key
    // ------------------------------

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            overlay.classList.remove("active");
        }
    });

    // ------------------------------
    // Enter Key
    // ------------------------------

    pinInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
            checkDelivery();
        }
    });

    // ------------------------------
    // Check Button
    // ------------------------------

    checkBtn.addEventListener("click", checkDelivery);

    // ==========================================
    // MAIN FUNCTION
    // ==========================================

    async function checkDelivery() {

        const pin = pinInput.value.trim();

        if (!/^\d{6}$/.test(pin)) {
            showError("Please enter a valid 6-digit PIN Code.");
            return;
        }

        if (!PRODUCT_REGIONS.length) {
            console.warn("PRODUCT_REGIONS is empty — check the delivery_regions metafield on this product.");
        }

        result.innerHTML = `
            <div class="delivery-loading">
                Checking availability...
            </div>
        `;

        try {

            const response = await fetch(
                `https://api.postalpincode.in/pincode/${pin}`
            );

            const data = await response.json();

            if (
                !Array.isArray(data) ||
                !data.length ||
                data[0].Status !== "Success" ||
                !data[0].PostOffice ||
                !data[0].PostOffice.length
            ) {
                showError("Invalid PIN Code.");
                return;
            }

            const office = data[0].PostOffice[0];
            const { supported, district, state } = isRegionSupported(office);

            if (supported) {

                localStorage.setItem("deliveryPin", pin);
                localStorage.setItem("deliveryDistrict", district);
                localStorage.setItem("deliveryState", state);

                showSuccess(pin, district, state);

            } else {

                localStorage.removeItem("deliveryPin");
                localStorage.removeItem("deliveryDistrict");
                localStorage.removeItem("deliveryState");

                showUnavailable(district, state);

            }

        } catch (err) {

            console.error(err);
            showError("Unable to verify delivery right now. Please try again later.");

        }

    }

    // ==========================================
    // LOAD SAVED LOCATION
    // ==========================================

    function loadSavedLocation() {

        const pin = localStorage.getItem("deliveryPin");

        if (!pin) return;

        deliveryText.innerHTML = `
            Deliver to
            <strong>${pin}</strong>
            <span class="delivery-change">Change</span>
        `;

        attachChangeHandler();

        verifySavedPin(pin);

    }

    async function verifySavedPin(pin) {

        try {

            const response = await fetch(
                `https://api.postalpincode.in/pincode/${pin}`
            );

            const data = await response.json();

            if (
                !data.length ||
                data[0].Status !== "Success" ||
                !data[0].PostOffice
            ) return;

            const office = data[0].PostOffice[0];
            const { supported, district, state } = isRegionSupported(office);

            if (supported) {

                result.innerHTML = `
                    <div class="delivery-success">
                        <div class="icon">✅</div>
                        <h4>Delivery Available</h4>
                        <p>
                            This product can be delivered to
                            <strong>${district}, ${state}</strong>
                        </p>
                    </div>
                `;

            } else {

                showUnavailable(district, state);

            }

        } catch (err) {
            console.error(err);
        }

    }

    // ==========================================
    // SUCCESS UI
    // ==========================================

    function showSuccess(pin, district, state) {

        localStorage.setItem("deliveryPin", pin);

        deliveryText.innerHTML = `
            Deliver to
            <strong>${pin}</strong>
            <span class="delivery-change">Change</span>
        `;

        attachChangeHandler();

        result.innerHTML = `
            <div class="delivery-success">
                <div class="icon">✅</div>
                <h4>Delivery Available</h4>
                <p>
                    This product can be delivered to
                    <strong>${district}, ${state}</strong>
                </p>
            </div>
        `;

        overlay.classList.remove("active");

    }

    // ==========================================
    // UNAVAILABLE UI — show Ghee fallback + other product links
    // ==========================================

    function showUnavailable(district, state) {

        let ghieBlock = "";

        if (GHEE_PRODUCT.available) {

            ghieBlock = `
                <a href="${GHEE_PRODUCT.url}" class="ghee-fallback-card">
                    ${GHEE_PRODUCT.image ? `<img src="${GHEE_PRODUCT.image}" alt="${GHEE_PRODUCT.title}" class="ghee-fallback-img">` : ""}
                    <div class="ghee-fallback-info">
                        <small>Available all over India</small>
                        <strong>${GHEE_PRODUCT.title}</strong>
                    </div>
                </a>
            `;

        }

        let otherProductsBlock = "";

        if (OTHER_PRODUCTS.length) {

            otherProductsBlock = `
                <div class="other-products-list">
                    <p class="other-products-title">You may also like:</p>
                    ${OTHER_PRODUCTS.map(p => `
                        <a href="${p.url}" class="other-product-link">${p.title}</a>
                    `).join("")}
                </div>
            `;

        }

        result.innerHTML = `
            <div class="delivery-error">

                <div class="icon">📍</div>

                <h4>
                    Not Deliverable
                </h4>

                <p>
                    Unfortunately, this product is currently unavailable in
                    <strong>${district}, ${state}</strong>.
                </p>

                ${ghieBlock}

                ${otherProductsBlock}

                <div class="delivery-app-box">

                    <h5>Get the Moovana App</h5>

                    <p>
                        Download the Moovana app to explore products,
                        receive delivery updates and access exclusive offers.
                    </p>

                    <div class="store-buttons">

                        <a
                            href="https://play.google.com/store/apps/details?id=com.mrmilkman.moovana"
                            target="_blank"
                            class="store-btn playstore">

                            <span class="store-icon">▶</span>

                            <div>
                                <small>GET IT ON</small>
                                <strong>Google Play</strong>
                            </div>

                        </a>

                        <a
                            href="https://apps.apple.com/in/app/moovana/id6744137808"
                            target="_blank"
                            class="store-btn appstore">

                            <span class="store-icon"></span>

                            <div>
                                <small>Download on the</small>
                                <strong>App Store</strong>
                            </div>

                        </a>

                    </div>

                </div>

            </div>
        `;

    }

    // ==========================================
    // CHANGE PIN HANDLER
    // ==========================================

    function attachChangeHandler() {

        const changeEl = document.querySelector(".delivery-change");

        if (changeEl) {
            changeEl.onclick = openModal;
        }

    }

    // ==========================================
    // SIMPLE ERROR
    // ==========================================

    function showError(message) {
        result.innerHTML = `
            <div class="delivery-error">
                ${message}
            </div>
        `;
    }

});